$(document).ready(function() {
    var index = $('.product__thumbs--scroller [data-left-frame]').data('index');
      var flkty = Flickity.data('.product-slideshow');
      if(flkty)
      {
flkty.select(index);
      }
      
      
    function updateDataAttributes() {
        var selectedSize = $('input[name="Size"]:checked').val();
        var selectedFrame = $('input[name="Frame"]:checked').val();
        // Border comes from the fk radios (the border dropdown UI was removed);
        // old dropdown selector kept as fallback.
        var selectedBorder = document.querySelector('.amr-Border .fk-selector-wrapper input:checked')?.value
            || document.querySelector('.amr-Border .variant_select-product.active_seclet .value_option')?.textContent.trim() || '';
        // console.log(selectedBorder);
        $('.grid--product-images--partial')
            .attr('data-size', selectedSize)
            .attr('data-frame', selectedFrame)
            .attr('data-border', selectedBorder.replace(/\s+/g, '-'));
            
    }
    
    // $('input[name="Size"], input[name="Frame"], input[name="Border Options"]').change(function() {
    //     updateDataAttributes();
    // });
    //     updateDataAttributes();
// $('input[name="Border Options"]').change(function() {
//   $('input[type="radio"][name="Frame"]').prop('checked', true).trigger('change');
// });
   // Delegated + scoped so frame changes inside the quick-shop modal drive
   // the modal's own slideshow instead of the main page's.
   $(document).on('change', 'input[name="Frame"]', function() {
      var $section = $(this).closest('.product-section');
      var index = $section.find('.product__thumbs--scroller [data-left-frame]').data('index');
      var slideshowEl = $section.find('.product-slideshow')[0];
      if (index === undefined && !$section.length) {
        index = $('.product__thumbs--scroller [data-left-frame]').data('index');
      }
      var flkty = slideshowEl ? Flickity.data(slideshowEl) : Flickity.data('.product-slideshow');
      if (flkty && index !== undefined) {
        flkty.select(index);
      }
    });
  
});


